<template>
  <div class="card">
    <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs">
      <el-tab-pane name="first">
        <span slot="label" style="display: flex;align-items: center;justify-content: center"><svg
          xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 55.499 42" style="margin-right: 10px">
  <g id="组_1792" data-name="组 1792" transform="translate(-4832.25 -2573.41)">
    <path id="路径_681" data-name="路径 681"
          d="M4884.843,2615.41h-49.686a3.011,3.011,0,0,1-2.248-.892,2.529,2.529,0,0,1-.651-1.931.676.676,0,0,1,.008-.07l2.12-12.679a46.439,46.439,0,0,1-1.314-4.665c-.808-3.637-.771-6.015.115-7.27a2.311,2.311,0,0,1,1.971-.993h49.686a2.313,2.313,0,0,1,1.971.993c.885,1.254.923,3.632.115,7.27a46.439,46.439,0,0,1-1.314,4.665l2.12,12.679a.676.676,0,0,1,.008.07,2.529,2.529,0,0,1-.651,1.931A3.011,3.011,0,0,1,4884.843,2615.41Zm-51.091-2.683a1.009,1.009,0,0,0,.255.77,1.543,1.543,0,0,0,1.15.413h49.686a1.543,1.543,0,0,0,1.15-.413,1.009,1.009,0,0,0,.255-.77l-2.145-12.83a.747.747,0,0,1,.033-.375,45.325,45.325,0,0,0,1.332-4.688c.95-4.284.4-5.669.121-6.066a.818.818,0,0,0-.746-.358h-49.686a.818.818,0,0,0-.746.358c-.28.4-.829,1.782.121,6.066a45.325,45.325,0,0,0,1.332,4.688.747.747,0,0,1,.033.375Z"
          :fill="activeName == 'first'?'#ffffff':'#dbbd80'" />
    <path id="路径_682" data-name="路径 682"
          d="M4866.75,2592.91a.75.75,0,0,1-.75-.75v-13.5a3.627,3.627,0,0,0-3.75-3.75h-4.5a3.627,3.627,0,0,0-3.75,3.75v13.5a.75.75,0,0,1-1.5,0v-13.5a5.106,5.106,0,0,1,5.25-5.25h4.5a5.106,5.106,0,0,1,5.25,5.25v13.5A.75.75,0,0,1,4866.75,2592.91Z"
          :fill="activeName == 'first'?'#ffffff':'#dbbd80'" />
    <path id="路径_683" data-name="路径 683"
          d="M4860,2596.17a12.709,12.709,0,0,1,5.843,1.4,12.966,12.966,0,0,1,4.443,3.746c.074.1.143.2.208.292l.02.028a.75.75,0,0,1-.177,1.04l-9.9,7.106a.751.751,0,0,1-.875,0l-9.9-7.106a.75.75,0,0,1-.177-1.04l.02-.028c.066-.094.134-.192.207-.289a12.969,12.969,0,0,1,4.445-3.749A12.709,12.709,0,0,1,4860,2596.17Zm8.842,5.735a11.348,11.348,0,0,0-17.685,0l8.842,6.347Z"
          :fill="activeName == 'first'?'#ffffff':'#dbbd80'" />
  </g>
</svg>
 館内</span>
      </el-tab-pane>
      <el-tab-pane name="second">
        <span slot="label" style="display: flex;align-items: center;justify-content: center"><svg
          xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 45.644 45.645"
          style="margin-right: 10px">
  <g id="组_2287" data-name="组 2287" transform="translate(-2766.4 -4569.178)">
    <g id="组_2286" data-name="组 2286">
      <path id="路径_840" data-name="路径 840"
            d="M2778.16,4585.607a.6.6,0,0,1,.411.163l25.756,24.251a.6.6,0,0,1,.013.861l-3.764,3.764a.6.6,0,0,1-.424.176h-.009a.6.6,0,0,1-.428-.189l-24.251-25.756a.6.6,0,0,1,.012-.835l2.259-2.259A.6.6,0,0,1,2778.16,4585.607Zm24.895,24.864-24.882-23.428-1.436,1.436,23.428,24.882Z"
            :fill="activeName == 'second'?'#ffffff':'#dbbd80'" />
      <path id="路径_841" data-name="路径 841"
            d="M2785.688,4578.079a.6.6,0,0,1,.411.163l25.756,24.251a.6.6,0,0,1,.013.861l-3.764,3.764a.6.6,0,0,1-.424.176h-.009a.6.6,0,0,1-.428-.189l-24.251-25.757a.6.6,0,0,1,.013-.835l2.259-2.258A.6.6,0,0,1,2785.688,4578.079Zm24.895,24.864-24.882-23.428-1.436,1.435,23.428,24.883Z"
            :fill="activeName == 'second'?'#ffffff':'#dbbd80'" />
    </g>
    <path id="路径_842" data-name="路径 842"
          d="M2786.225,4608.827A19.836,19.836,0,1,1,2806.049,4589a.6.6,0,0,1-1.2,0,18.624,18.624,0,1,0-18.624,18.625.6.6,0,0,1,0,1.2Z"
          :fill="activeName == 'second'?'#ffffff':'#dbbd80'" />
  </g>
</svg> 試吃</span>
      </el-tab-pane>
      <el-tab-pane name="third">
        <span slot="label" style="display: flex;align-items: center;justify-content: center"><svg
          xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 50.089 28.544"
          style="margin-right: 10px">
  <g id="组_2295" data-name="组 2295" transform="translate(-3041.863 -4578.728)">
    <g id="组_2294" data-name="组 2294">
      <g id="组_2293" data-name="组 2293">
        <g id="组_2292" data-name="组 2292">
          <g id="组_2291" data-name="组 2291">
            <path id="路径_844" data-name="路径 844"
                  d="M3076.437,4602.3h-19.525a.6.6,0,0,1,0-1.2h19.525a.6.6,0,0,1,0,1.2Z"
                  :fill="activeName == 'third'?'#ffffff':'#dbbd80'" />
            <path id="路径_845" data-name="路径 845"
                  d="M3081.409,4596.129a5.572,5.572,0,1,1-5.572,5.571A5.578,5.578,0,0,1,3081.409,4596.129Zm0,9.943a4.371,4.371,0,1,0-4.372-4.372A4.377,4.377,0,0,0,3081.409,4606.072Z"
                  :fill="activeName == 'third'?'#ffffff':'#dbbd80'" />
            <path id="路径_846" data-name="路径 846"
                  d="M3051.164,4596.129a5.572,5.572,0,1,1-5.572,5.571A5.578,5.578,0,0,1,3051.164,4596.129Zm0,9.943a4.371,4.371,0,1,0-4.372-4.372A4.376,4.376,0,0,0,3051.164,4606.072Z"
                  :fill="activeName == 'third'?'#ffffff':'#dbbd80'" />
          </g>
        </g>
      </g>
      <path id="路径_847" data-name="路径 847"
            d="M3046.192,4602.3a.6.6,0,0,1-.19-.031l-3.729-1.242a.6.6,0,0,1-.41-.569v-6.707a3.086,3.086,0,0,1,2.417-3.012l.026,0,9.921-1.738a4.369,4.369,0,0,0,2.13-1.173l7.828-7.828a4.3,4.3,0,0,1,3.06-1.268h17.6a3.07,3.07,0,0,1,2.761,1.706l4.022,8.044a3.117,3.117,0,0,1,.325,1.38v8.659a3.08,3.08,0,0,1-2.338,2.993l-3.088.772a.6.6,0,0,1-.291-1.164l3.088-.772a1.883,1.883,0,0,0,1.428-1.829v-8.659a1.907,1.907,0,0,0-.2-.845l-4.021-8.042a1.876,1.876,0,0,0-1.687-1.042h-17.6a3.108,3.108,0,0,0-2.212.916l-7.828,7.828a5.571,5.571,0,0,1-2.731,1.5l-.027,0-9.921,1.738a1.9,1.9,0,0,0-1.464,1.837v6.274l3.319,1.105a.6.6,0,0,1-.19,1.169Z"
            :fill="activeName == 'third'?'#ffffff':'#dbbd80'" />
      <path id="直线_615" data-name="直线 615"
            d="M14.653.6H0A.6.6,0,0,1-.6,0,.6.6,0,0,1,0-.6H14.653a.6.6,0,0,1,.6.6A.6.6,0,0,1,14.653.6Z"
            transform="translate(3076.437 4588.747)" :fill="activeName == 'third'?'#ffffff':'#dbbd80'" />
    </g>
    <path id="路径_848" data-name="路径 848"
          d="M3068.284,4587.978a9.294,9.294,0,0,1,4.274,1.026,9.484,9.484,0,0,1,3.248,2.739c.045.059.085.116.123.171l.043.062a.6.6,0,0,1-.139.834l-7.2,5.168a.6.6,0,0,1-.7,0l-7.2-5.168a.6.6,0,0,1-.139-.834l.043-.062c.039-.056.079-.114.125-.173a9.485,9.485,0,0,1,3.248-2.737A9.293,9.293,0,0,1,3068.284,4587.978Zm6.352,4.215a8.2,8.2,0,0,0-12.7,0l6.352,4.559Z"
          :fill="activeName == 'third'?'#ffffff':'#dbbd80'" />
  </g>
</svg> 院外</span>
      </el-tab-pane>
      <el-tab-pane name="fourth">
        <span slot="label" style="display: flex;align-items: center;justify-content: center"><svg
          xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 45.644 45.644"
          style="margin-right: 10px">
  <g id="组_2301" data-name="组 2301" transform="translate(-3325.9 -4568.9)">
    <g id="组_2300" data-name="组 2300">
      <path id="路径_851" data-name="路径 851"
            d="M3345.885,4592.252a.6.6,0,0,1,.411.163l19.392,18.259a.6.6,0,0,1,.013.861l-2.834,2.833a.6.6,0,0,1-.424.176h-.009a.6.6,0,0,1-.428-.189l-18.259-19.391a.6.6,0,0,1,.012-.835l1.7-1.7A.6.6,0,0,1,3345.885,4592.252Zm18.531,18.872-18.518-17.436-.878.878,17.436,18.517Z"
            :fill="activeName == 'fourth'?'#ffffff':'#dbbd80'" />
      <path id="路径_852" data-name="路径 852"
            d="M3351.553,4586.584a.6.6,0,0,1,.411.163l19.391,18.259a.6.6,0,0,1,.013.861l-2.833,2.834a.6.6,0,0,1-.424.176h-.009a.6.6,0,0,1-.428-.189l-18.259-19.392a.6.6,0,0,1,.012-.835l1.7-1.7A.6.6,0,0,1,3351.553,4586.584Zm18.53,18.872-18.517-17.436-.877.877,17.436,18.518Z"
            :fill="activeName == 'fourth'?'#ffffff':'#dbbd80'" />
    </g>
    <path id="路径_853" data-name="路径 853"
          d="M3351.957,4610.067a15.074,15.074,0,1,1,15.074-15.074.6.6,0,0,1-1.2,0,13.874,13.874,0,1,0-13.874,13.874.6.6,0,0,1,0,1.2Z"
          :fill="activeName == 'fourth'?'#ffffff':'#dbbd80'" />
    <path id="路径_850" data-name="路径 850"
          d="M3333.992,4599.048a8.1,8.1,0,0,1-8.092-8.092v-13.964a8.1,8.1,0,0,1,8.092-8.092h13.964a8.1,8.1,0,0,1,8.092,8.092.6.6,0,0,1-1.2,0,6.9,6.9,0,0,0-6.892-6.892h-13.964a6.9,6.9,0,0,0-6.892,6.892v13.964a6.9,6.9,0,0,0,6.892,6.892.6.6,0,0,1,0,1.2Z"
          :fill="activeName == 'fourth'?'#ffffff':'#dbbd80'" />
  </g>
</svg> 陪宿</span>
      </el-tab-pane>
    </el-tabs>
    <div class="tableBody">
      <el-input
        placeholder="請輸入姓名、房號搜尋訂單"
        suffix-icon="el-icon-search"
        v-model="form.keyword"
        @change="getOrderList"
      >
      </el-input>
      <div class="right">
        <el-popover
          placement="bottom"
          width="470"
          trigger="click"
          v-model="visible">
          <div class="shuai">
            <div>
              <p>訂餐情況</p>
              <el-radio-group v-model="form.item">
                <el-radio :label="null">全部</el-radio>
                <el-radio :label="1">月子膳食</el-radio>
                <el-radio :label="2">養胎膳食</el-radio>
                <el-radio :label="3">小產膳食</el-radio>
                <el-radio :label="4">術後膳食</el-radio>
                <el-radio :label="5">生理膳食</el-radio>
              </el-radio-group>
            </div>

            <div>
              <p>選菜功能</p>
              <el-radio-group v-model="form.choose">
                <el-radio :label="null">全部</el-radio>
                <el-radio :label="1">已開通</el-radio>
                <el-radio :label="0">未開通</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="popoverBtn">
            <el-button @click="reset">清除篩選條件</el-button>
            <el-button @click="getOrderList">確認篩選</el-button>
          </div>
          <p slot="reference"><img src="@/assets/image/ico101.svg" />篩選</p>
        </el-popover>
        <div>
          <span>排序</span>
          <el-select v-model="form.sort" placeholder="請選擇" @change="getOrderList">
            <el-option label="預設排序方式" value=""></el-option>
            <el-option label="最近編輯時間優先" value="updated_at"></el-option>
            <el-option label="最近起餐時間優先" value="start_date"></el-option>
            <el-option label="系統編號：升序" value="id"></el-option>
            <el-option label="系統編號：降序" :value="5"></el-option>
          </el-select>
        </div>
      </div>
    </div>

    <el-table
      :data="tableData"
      style="width: 100%;margin-top: 20px"
      :header-cell-style="{'background':'#C6C6C6','color':'#ffffff'}">

        <el-table-column
          prop="id"
          label="編號"
        >
        </el-table-column>
        <el-table-column
          prop="agency_room_info.name"
          label="房號"
          v-if="activeName == 'first'"
        >
        </el-table-column>
        <el-table-column
          prop="user_name"
          label="客戶名稱">
        </el-table-column>
        <el-table-column
          prop="order_detail"
          label="出餐餐期">
          <template v-slot="{row}">
             <span v-for="(item,i) in row.order_detail" :key="i">
                 {{ (item.stage == 1 ? "早餐" : item.stage == 2 ? "午餐" : "晚餐") + (i == row.order_detail.length - 1 ? "" : " / ")
               }}
             </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="item"
          label="餐點類型">
          <template v-slot="{row}">
            {{ $itemDate.find(item => item.id == row.item) ? $itemDate.find(item => item.id == row.item).name : "" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="user_info.choose"
          label="選菜功能"
          v-if="activeName != 'second' && activeName != 'fourth'"
        >
          <template v-slot="{row}">
            {{ row.user_info.choose == 1?"已開通":"未開通" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="agency_room_info.name"
          label="出餐房號"
          v-if="activeName == 'fourth'"
        >
        </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top: 20px"
      background
      layout="prev, pager, next"
      :total="total"
      @current-change="handleCurrentChange">
    </el-pagination>

  </div>
</template>
<script>
import { todayOrderList } from "@/api";

export default {
  name: "list.vue",
  props: {
    type: {
      type: String,
      default: "first"
    }
  },
  data() {
    return {
      activeName: "first",
      form: {
        keyword: "",
        item: null,
        choose: null,
        order: "",
        sort: "",
        page: 1,
        limit: 10,
        mold: 1,
        date: ""
      },
      tableData: [],
      total: 0,
      visible: false
    };
  },
  mounted() {
    this.activeName = this.type;
    if (this.activeName == "first") {
      this.form.mold = 1;
    } else if (this.activeName == "second") {
      this.form.mold = 3;
    } else if (this.activeName == "third") {
      this.form.mold = 2;
    } else {
      this.form.mold = 4;
    }
    this.getOrderList();
  },
  methods: {
    getOrderList() {
      this.visible = false;
      todayOrderList(
        {
          page: this.form.page,
          limit: this.form.limit,
          item: this.form.item,
          choose: this.form.choose,
          keyword: this.form.keyword,
          sort: this.form.sort == 5 ? "id" : this.form.sort,
          order: this.form.sort == "id" ? "asc" : this.form.sort == "" ? "" : "desc",
          mold: this.form.mold,
          date: this.$store.state.dataTime.date
        }
      ).then(res => {
        this.tableData = res.data.list;
        this.total = res.data.total;
      });
    },
    reset() {
      this.form.item = null;
      this.form.choose = null;
      this.getOrderList();
    },
    resstAll() {
      this.form = {
        keyword: "",
        item: null,
        choose: null,
        order: "",
        sort: "",
        page: 1,
        limit: 10,
        mold: 1
      };
    },
    handleClick() {
      this.resstAll();
      if (this.activeName == "first") {
        this.form.mold = 1;
      } else if (this.activeName == "second") {
        this.form.mold = 3;
      } else if (this.activeName == "third") {
        this.form.mold = 2;
      } else {
        this.form.mold = 4;
      }
      this.getOrderList();
    },
    handleCheck() {

    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.getOrderList();
    }
  },
  watch:{
    '$store.state.dataTime.date'(){
        this.getOrderList()
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-tabs__active-bar {
  display: none !important;
}

::v-deep .el-tabs__header {
  padding-bottom: 0 !important;
}

::v-deep .el-tabs__item.is-active {
  background: #DBBD80;
  border-radius: 25px;
  color: #FFFFFF;

}

.img {
  filter: brightness(100%) !important;
}

::v-deep .el-tabs__item {
  color: #DBBD80;
}

.tabs {
  margin-top: 20px;
}

.card {
  padding: 20px;
  border-radius: 15px;
  background: #FFFFFF;
  margin-top: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.tableBody {
  display: flex;
  align-items: center;
  justify-content: space-between;

  ::v-deep .el-input__inner {
    border: none;
    background: #F8F8F8;
  }

  .el-input {
    width: 300px;
  }

  .right {
    display: flex;
    align-items: center;
    white-space: nowrap;

    img {
      width: 16px;
      height: 16px;
      object-fit: contain;
      margin-right: 5px;
    }

    p {
      margin: 0;
      color: #b6b8bd;
      cursor: pointer;
    }

    div {
      display: flex;
      align-items: center;
      margin-left: 20px;

      span {
        color: #b6b8bd;
        border-right: 2px solid #b6b8bd;
        padding-right: 10px;
      }

      ::v-deep .el-input__inner {
        border: none !important;
      }

    }
  }
}

.shuai {
  display: flex;
  align-items: stretch;
  overflow-x: auto;

  div {
    width: 200px;
    min-width: 200px;
    margin-right: 20px;
    font-size: 20px;

    .el-checkbox {
      display: block;
      margin-bottom: 10px;
      font-size: 20px;
    }

    .el-radio {
      display: block;
      margin-bottom: 10px;
      font-size: 20px;
    }

    ::v-deep .el-radio__inner {
      border-radius: 2px;
    }

    ::v-deep .el-radio__input.is-checked .el-radio__inner {
      border-color: #DBBD80;
      background: #DBBD80;
    }

    ::v-deep .el-radio__inner::after {
      display: none;
    }

    ::v-deep .el-radio__input.is-checked + .el-radio__label {
      color: #DBBD80;
    }
  }
}

.el-button--text {
  color: #DBBD80;
  padding: 5px 10px;
  border: 1px solid #DBBD80;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #DBBD80;
  color: #FFFFFF !important;
}

.popoverBtn {
  margin: 10px auto;
  text-align: center;

  .el-button, .el-button:focus {
    border-color: #DBBD80;
    color: #DBBD80;
  }

  .el-button:hover {
    background: #DBBD80;
    color: #FFFFFF;
  }
}
</style>
